export const halfAddrShow = (addr) => {
  if (addr) {
    return addr.substring(0, 6) + "......" + addr.slice(addr.length - 5);
  } else {
    return "";
  }
};
